export const GET_CUSTOMER_ORDERING_PREFERENCES_REQUESTED = 'GET_CUSTOMER_ORDERING_PREFERENCES_REQUESTED'
export const GET_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED = 'GET_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED'
export const GET_CUSTOMER_ORDERING_PREFERENCES_FAILED = 'GET_CUSTOMER_ORDERING_PREFERENCES_FAILED'

export const CREATE_CUSTOMER_ORDERING_PREFERENCES_REQUESTED = 'CREATE_CUSTOMER_ORDERING_PREFERENCES_REQUESTED'
export const CREATE_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED = 'CREATE_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED'
export const CREATE_CUSTOMER_ORDERING_PREFERENCES_FAILED = 'CREATE_CUSTOMER_ORDERING_PREFERENCES_FAILED'

export const REMOVE_CUSTOMER_ORDERING_PREFERENCE_REQUESTED = 'REMOVE_CUSTOMER_ORDERING_PREFERENCE_REQUESTED'
export const REMOVE_CUSTOMER_ORDERING_PREFERENCE_SUCCEEDED = 'REMOVE_CUSTOMER_ORDERING_PREFERENCE_SUCCEEDED'
export const REMOVE_CUSTOMER_ORDERING_PREFERENCE_FAILED = 'REMOVE_CUSTOMER_ORDERING_PREFERENCE_FAILED'
export const REMOVE_OPTIMISTIC_CUSTOMER_ORDERING_PREFERENCE_SUCCEEDED = 'REMOVE_OPTIMISTIC_CUSTOMER_ORDERING_PREFERENCE_SUCCEEDED'

export const CREATE_OPTIMISTIC_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED = 'CREATE_OPTIMISTIC_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED'
